import { Box, css } from '@mui/material'
import { useMQ } from '../hooks/useMQ'

type Props = {
  title: string
}

export function Title({ title }: Props) {
  const { isXsSize } = useMQ()

  const styles = {
    wrapper: css`
      width: 100%;
      z-index: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    `,
    title: css`
      font-family: 'Red-Hat-Display';
      margin-bottom: ${isXsSize ? '24px' : '40px'};
      font-weight: 900;
      font-size: ${isXsSize ? '24px' : '40px'};
      line-height: ${isXsSize ? '24px' : '48px'};
      text-align: center;
      z-index: 1;
      position: relative;
      background: linear-gradient(45deg, #fff 0%, #d8d8d8 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    `,
  }

  return (
    <Box css={styles.wrapper}>
      <Box css={styles.title}>{title}</Box>
    </Box>
  )
}
